import { IAddressComponent, IDictionary, IAddress } from "./types";

export const getAddressObject = (place: google.maps.places.PlaceResult) => {
  var ShouldBeComponent: IDictionary<string[]> = {
    Unit: ["subpremise"],
    StreetNumber: ["street_number"],
    PostalCode: ["postal_code"],
    StreetAddress: ["street_address", "route"],
    StateProvince: [
      "administrative_area_level_1",
      "administrative_area_level_2",
      "administrative_area_level_3",
      "administrative_area_level_4",
      "administrative_area_level_5",
    ],
    City: [
      "locality",
      "sublocality",
      "sublocality_level_1",
      "sublocality_level_2",
      "sublocality_level_3",
      "sublocality_level_4",
    ],
    Country: ["country"],
  };

  var address: Partial<IAddress> = {};

  const { address_components } = place;

  if (address_components) {
    address_components.forEach((component) => {
      let shouldBe: string;
      for (shouldBe in ShouldBeComponent) {
        if (ShouldBeComponent[shouldBe].indexOf(component.types[0]) !== -1) {
          (address as any)[shouldBe] = {
            ShortName: component.short_name,
            LongName: component.long_name,
          } as IAddressComponent;
        }
      }
    });
  }
  address.GooglePlaceId = place.place_id;
  address.FormattedAddress = place.formatted_address;
  address.Lat = place.geometry?.location?.lat();
  address.Lng = place.geometry?.location?.lng();

  return address;
};

export const isBrowser = typeof window !== "undefined" && window.document;

export const loadGoogleMapScript = (
  googleMapsScriptBaseUrl: string,
  googleMapsScriptUrl: string
) => {
  if (!isBrowser) return Promise.resolve();

  if (typeof google !== "undefined") {
    if (google.maps && (google.maps as any).api) return Promise.resolve();
  }

  const scriptElements = document.querySelectorAll(
    `script[src*="${googleMapsScriptBaseUrl}"]`
  );

  if (scriptElements && scriptElements.length) {
    return new Promise((resolve) => {
      // in case we already have a script on the page and it's loaded we resolve
      if (typeof google !== "undefined") return resolve;

      // otherwise we wait until it's loaded and resolve
      scriptElements[0].addEventListener("load", () => resolve);
    });
  }

  let scriptUrl = new URL(googleMapsScriptUrl);
  scriptUrl.searchParams.set(
    "callback",
    "__REACT_GOOGLE_AUTOCOMPLETE_CALLBACK__"
  );
  const el = document.createElement("script");
  el.src = scriptUrl.toString();

  return new Promise((resolve) => {
    (window as any).__REACT_GOOGLE_AUTOCOMPLETE_CALLBACK__ = resolve;
    document.body.appendChild(el);
  });
};
